[
  {
    "id": "TB-B6-001",
    "module": "Taalbegrip",
    "difficulty": 101,
    "question": "Lees de tekst:\n\n\"De eekhoorn verstopt nootjes in de grond. In de winter graaft hij ze weer op. Soms vergeet hij waar ze liggen. Dan groeit er een nieuw boompje!\"\n\nWaarom groeit er soms een nieuw boompje?",
    "options": [
      "Omdat de eekhoorn vergeet waar de nootjes liggen",
      "Omdat de eekhoorn ze opeet",
      "Omdat het winter is",
      "Omdat de eekhoorn ze in een boom verstopt"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tekstbegrip",
    "subSkill": "letterlijk_begrip",
    "familyId": "TB-EEKHOORN",
    "explanation": "In de tekst staat: 'Soms vergeet hij waar ze liggen. Dan groeit er een nieuw boompje!' De nootjes die vergeten worden, groeien uit tot een boom.",
    "distractorExplanations": {
      "1": "Als hij ze opeet, kunnen ze niet groeien.",
      "2": "Het seizoen is niet de reden dat er een boompje groeit.",
      "3": "Hij verstopt ze in de grond, niet in een boom."
    }
  },
  {
    "id": "TB-B6-002",
    "module": "Taalbegrip",
    "difficulty": 101,
    "question": "Lees de tekst:\n\n\"Pinguïns kunnen niet vliegen, maar ze zijn uitstekende zwemmers. Ze gebruiken hun vleugels als flippers onder water.\"\n\nWat gebruiken pinguïns als flippers?",
    "options": [
      "Hun vleugels",
      "Hun poten",
      "Hun staart",
      "Hun snavel"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tekstbegrip",
    "subSkill": "letterlijk_begrip",
    "familyId": "TB-PINGUINS",
    "explanation": "In de tekst staat letterlijk: 'Ze gebruiken hun vleugels als flippers onder water.'",
    "distractorExplanations": {
      "1": "De tekst noemt vleugels, niet poten.",
      "2": "De staart wordt niet genoemd.",
      "3": "De snavel wordt niet genoemd."
    }
  },
  {
    "id": "TB-B6-003",
    "module": "Taalbegrip",
    "difficulty": 101,
    "question": "Lees de tekst:\n\n\"Vandaag is het de verjaardag van Sanne. Ze wordt 10 jaar. Haar moeder heeft een chocoladetaart gebakken. Er komen 8 vrienden.\"\n\nHoe oud wordt Sanne?",
    "options": [
      "10 jaar",
      "8 jaar",
      "9 jaar",
      "11 jaar"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tekstbegrip",
    "subSkill": "letterlijk_begrip",
    "familyId": "TB-VERJAARDAG",
    "explanation": "In de tekst staat: 'Ze wordt 10 jaar.' Het getal 8 gaat over het aantal vrienden.",
    "distractorExplanations": {
      "1": "8 is het aantal vrienden, niet haar leeftijd.",
      "2": "Dit staat niet in de tekst.",
      "3": "Dit staat niet in de tekst."
    }
  },
  {
    "id": "TB-B6-004",
    "module": "Taalbegrip",
    "difficulty": 101,
    "question": "Lees de tekst:\n\n\"De zon schijnt en het is warm. Tim pakt zijn zwembroek en een handdoek. Hij fietst naar het zwembad.\"\n\nWaar gaat Tim naartoe?",
    "options": [
      "Naar het zwembad",
      "Naar het strand",
      "Naar school",
      "Naar het park"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tekstbegrip",
    "subSkill": "letterlijk_begrip",
    "familyId": "TB-ZWEMBAD",
    "explanation": "In de laatste zin staat: 'Hij fietst naar het zwembad.'",
    "distractorExplanations": {
      "1": "Er staat zwembad, niet strand.",
      "2": "Tim gaat niet naar school.",
      "3": "Tim gaat niet naar het park."
    }
  },
  {
    "id": "TB-B6-005",
    "module": "Taalbegrip",
    "difficulty": 101,
    "question": "Lees de tekst:\n\n\"Katten slapen gemiddeld 16 uur per dag. Ze zijn vooral 's nachts actief. Daarom noemen we katten nachtdieren.\"\n\nWaarom noemen we katten nachtdieren?",
    "options": [
      "Omdat ze vooral 's nachts actief zijn",
      "Omdat ze 16 uur slapen",
      "Omdat ze bang zijn in het donker",
      "Omdat ze overdag buiten spelen"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tekstbegrip",
    "subSkill": "letterlijk_begrip",
    "familyId": "TB-KATTEN",
    "explanation": "De tekst zegt: 'Ze zijn vooral 's nachts actief. Daarom noemen we katten nachtdieren.' Het woord 'daarom' legt het verband uit.",
    "distractorExplanations": {
      "1": "Dat klopt, maar dat is niet de reden dat ze nachtdieren heten.",
      "2": "Dit staat niet in de tekst.",
      "3": "Dit staat niet in de tekst."
    }
  },
  {
    "id": "TB-B6-006",
    "module": "Taalbegrip",
    "difficulty": 101,
    "question": "Lees de tekst:\n\n\"De bibliotheek is elke dag open, behalve op zondag. Je mag maximaal 5 boeken lenen. Na 3 weken moet je ze terugbrengen.\"\n\nHoeveel boeken mag je maximaal lenen?",
    "options": [
      "5 boeken",
      "3 boeken",
      "7 boeken",
      "Zo veel als je wilt"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tekstbegrip",
    "subSkill": "letterlijk_begrip",
    "familyId": "TB-BIEB",
    "explanation": "In de tekst staat: 'Je mag maximaal 5 boeken lenen.' Het getal 3 gaat over het aantal weken.",
    "distractorExplanations": {
      "1": "3 is het aantal weken, niet het aantal boeken.",
      "2": "Dit staat niet in de tekst.",
      "3": "Er staat 'maximaal 5', dus niet onbeperkt."
    }
  },
  {
    "id": "TB-B6-007",
    "module": "Taalbegrip",
    "difficulty": 101,
    "question": "Lees de tekst:\n\n\"De spin maakt een web om insecten te vangen. Het web is heel sterk en plakkerig. Als een vlieg erin vliegt, kan hij niet meer weg.\"\n\nWat is een goede titel voor deze tekst?",
    "options": [
      "Het slimme web van de spin",
      "De vlieg die kon vliegen",
      "Insecten in de tuin",
      "Hoe maak je lijm?"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tekstanalyse",
    "subSkill": "hoofdgedachte",
    "familyId": "TB-SPIN",
    "explanation": "De tekst gaat over hoe de spin een web maakt om insecten te vangen. 'Het slimme web van de spin' past het beste als titel.",
    "distractorExplanations": {
      "1": "De tekst gaat niet over de vlieg, maar over de spin.",
      "2": "De tekst gaat specifiek over het web, niet over insecten in het algemeen.",
      "3": "De tekst gaat niet over lijm maken."
    }
  },
  {
    "id": "TB-B6-008",
    "module": "Taalbegrip",
    "difficulty": 101,
    "question": "Lees de tekst:\n\n\"Vroeger schreven mensen met een ganzenveer. Ze doopten de veer in inkt. Dat was best lastig, want de inkt druppelde vaak.\"\n\nWaarom was schrijven met een ganzenveer lastig?",
    "options": [
      "Omdat de inkt vaak druppelde",
      "Omdat ganzen niet stil konden zitten",
      "Omdat er geen papier was",
      "Omdat de veer te groot was"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tekstbegrip",
    "subSkill": "letterlijk_begrip",
    "familyId": "TB-GANZENVEER",
    "explanation": "De tekst zegt: 'Dat was best lastig, want de inkt druppelde vaak.' Het woord 'want' geeft de reden aan.",
    "distractorExplanations": {
      "1": "De tekst gaat over de veer als schrijfgereedschap, niet over levende ganzen.",
      "2": "Er staat niet dat er geen papier was.",
      "3": "De grootte van de veer wordt niet genoemd."
    }
  },
  {
    "id": "TB-B6-009",
    "module": "Taalbegrip",
    "difficulty": 101,
    "question": "Lees de tekst:\n\n\"Een kameel kan wekenlang zonder water. Hij slaat vet op in zijn bulten. Dat vet geeft hem energie als er geen eten is.\"\n\nWat zit er in de bulten van een kameel?",
    "options": [
      "Vet",
      "Water",
      "Zand",
      "Lucht"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tekstbegrip",
    "subSkill": "letterlijk_begrip",
    "familyId": "TB-KAMEEL",
    "explanation": "In de tekst staat: 'Hij slaat vet op in zijn bulten.' Veel mensen denken water, maar het is vet.",
    "distractorExplanations": {
      "1": "Dit is een veelvoorkomend misverstand. De tekst zegt duidelijk 'vet'.",
      "2": "Zand wordt niet genoemd.",
      "3": "Lucht wordt niet genoemd."
    }
  },
  {
    "id": "TB-B6-010",
    "module": "Taalbegrip",
    "difficulty": 101,
    "question": "Wat betekent het woord 'uitstekend' in de zin: 'Pinguïns zijn uitstekende zwemmers.'",
    "options": [
      "Heel goed",
      "Heel slecht",
      "Heel groot",
      "Heel snel"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "woordenschat",
    "subSkill": "woordbetekenis",
    "familyId": "TB-WOORD-UITSTEKEND",
    "explanation": "'Uitstekend' betekent 'heel goed' of 'voortreffelijk'. Pinguïns kunnen heel goed zwemmen.",
    "distractorExplanations": {
      "1": "Uitstekend is juist positief, niet negatief.",
      "2": "Het gaat niet over grootte.",
      "3": "Het gaat niet specifiek over snelheid, maar over hoe goed ze zwemmen."
    }
  },
  {
    "id": "TB-B6-011",
    "module": "Taalbegrip",
    "difficulty": 101,
    "question": "Lees de tekst:\n\n\"Lisa's hond Bello is ziek. Hij eet niet meer en ligt de hele dag op zijn kussen. Lisa maakt zich zorgen.\"\n\nHoe voelt Lisa?",
    "options": [
      "Bezorgd",
      "Blij",
      "Boos",
      "Verveeld"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tekstbegrip",
    "subSkill": "letterlijk_begrip",
    "familyId": "TB-LISA-HOND",
    "explanation": "In de tekst staat: 'Lisa maakt zich zorgen.' Dat betekent dat ze bezorgd is.",
    "distractorExplanations": {
      "1": "Lisa is niet blij, haar hond is ziek.",
      "2": "Er staat niet dat Lisa boos is.",
      "3": "Lisa is niet verveeld, ze maakt zich zorgen."
    }
  },
  {
    "id": "TB-B6-012",
    "module": "Taalbegrip",
    "difficulty": 101,
    "question": "Lees de tekst:\n\n\"In Nederland regent het vaak. Daarom dragen veel mensen een regenjas. Sommige mensen nemen ook een paraplu mee.\"\n\nWaarom dragen veel mensen een regenjas?",
    "options": [
      "Omdat het in Nederland vaak regent",
      "Omdat regenjassen mooi zijn",
      "Omdat het koud is",
      "Omdat iedereen dat doet"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tekstbegrip",
    "subSkill": "letterlijk_begrip",
    "familyId": "TB-REGEN-NL",
    "explanation": "De tekst zegt: 'In Nederland regent het vaak. Daarom dragen veel mensen een regenjas.' Het woord 'daarom' geeft de reden.",
    "distractorExplanations": {
      "1": "De tekst noemt niet dat regenjassen mooi zijn.",
      "2": "De tekst gaat over regen, niet over kou.",
      "3": "De tekst zegt 'veel mensen', niet 'iedereen'."
    }
  },
  {
    "id": "TB-B6-013",
    "module": "Taalbegrip",
    "difficulty": 101,
    "question": "Wat betekent het woord 'gemiddeld' in de zin: 'Katten slapen gemiddeld 16 uur per dag.'",
    "options": [
      "Ongeveer, als je het uitrekent over alle katten",
      "Precies, elke kat slaapt exact 16 uur",
      "Maximaal, geen kat slaapt langer",
      "Minimaal, elke kat slaapt minstens 16 uur"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "woordenschat",
    "subSkill": "woordbetekenis",
    "familyId": "TB-WOORD-GEMIDDELD",
    "explanation": "'Gemiddeld' betekent dat sommige katten meer slapen en sommige minder, maar als je het uitrekent is het ongeveer 16 uur.",
    "distractorExplanations": {
      "1": "Gemiddeld betekent niet precies. Sommige katten slapen meer, andere minder.",
      "2": "Gemiddeld is niet hetzelfde als maximaal.",
      "3": "Gemiddeld is niet hetzelfde als minimaal."
    }
  },
  {
    "id": "TB-B6-014",
    "module": "Taalbegrip",
    "difficulty": 101,
    "question": "Lees de tekst:\n\n\"De ijsbeer leeft op de Noordpool. Zijn witte vacht helpt hem om niet op te vallen in de sneeuw. Zo kan hij dicht bij zijn prooi komen.\"\n\nWaarom is de vacht van de ijsbeer wit?",
    "options": [
      "Om niet op te vallen in de sneeuw",
      "Omdat hij het koud heeft",
      "Omdat hij in het water zwemt",
      "Omdat alle beren wit zijn"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tekstbegrip",
    "subSkill": "letterlijk_begrip",
    "familyId": "TB-IJSBEER",
    "explanation": "De tekst zegt: 'Zijn witte vacht helpt hem om niet op te vallen in de sneeuw.' Dat is camouflage.",
    "distractorExplanations": {
      "1": "De kleur van de vacht heeft niets met warmte te maken.",
      "2": "De tekst noemt zwemmen niet als reden voor de kleur.",
      "3": "Niet alle beren zijn wit. Bruine beren zijn bruin."
    }
  },
  {
    "id": "TB-B6-015",
    "module": "Taalbegrip",
    "difficulty": 101,
    "question": "Lees de tekst:\n\n\"Tom heeft een nieuwe fiets. Hij is rood met zwarte strepen. Tom rijdt er elke dag mee naar school.\"\n\nWelke kleur heeft de fiets van Tom?",
    "options": [
      "Rood met zwarte strepen",
      "Zwart met rode strepen",
      "Alleen rood",
      "Alleen zwart"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tekstbegrip",
    "subSkill": "letterlijk_begrip",
    "familyId": "TB-FIETS-TOM",
    "explanation": "In de tekst staat: 'Hij is rood met zwarte strepen.' De hoofdkleur is rood, met zwarte strepen erop.",
    "distractorExplanations": {
      "1": "Het is andersom: rood is de hoofdkleur, zwart zijn de strepen.",
      "2": "De fiets heeft ook zwarte strepen.",
      "3": "De fiets is niet alleen zwart, maar rood met zwarte strepen."
    }
  }
]